import { getNotificationDetails, getNotificationList } from "./notification";
import {
  createunitEvBoostOperation,
  getSettingsStormOperation,
  getunitStormOperation,
} from "./operation";
import { getOptions } from "./option";
import { getPerformance } from "./performance";
import { getPlan } from "./plan";
import { getProfile } from "./profile";
import { currentSession, login } from "./session";
import { getSettings, getTariffList, updateSettings } from "./settings";
import { getSiteDetails } from "./site";
import { getSummary } from "./summary";
import { getNetworkAccessList, getNetworkSettings } from "./unit";
import { getVppKey } from "./vppKey";

const delay = () => new Promise((resolve) => setTimeout(resolve, 500));

export const MockApi = {
  get: async (apiName, path) => {
    await delay();
    return await get(path);
  },

  post: async (apiName, path) => {
    await delay();
    return post(path);
  },

  put: async (apiName, path, options) => {
    await delay();
    return put(path, options);
  },

  del: async (apiName, path, options) => {
    console.log("Mock API DELETE request:", { apiName, path, options });

    await delay();
    return { message: "Mock API Delete Success" };
  },
};

export const MockAuth = {
  signIn: async (email, password) => {
    await delay();
    return login(email, password);
  },
  currentSession: async () => {
    await delay();
    return currentSession();
  },
  signOut: async () => {
    await delay();
    return;
  },
  // Below are just placeholders, no need to mock these api calls.
  changePassword: async () => {
    return;
  },
  completeNewPassword: async () => {
    return;
  },
  forgotPassword: async () => {
    return;
  },
  forgotPasswordSubmit: async () => {
    return;
  },
};

const get = async (path) => {
  if (path === "/profile") {
    return getProfile();
  }

  if (path === "/option") {
    return getOptions();
  }

  const siteSettingsRegex = /^\/site\/([a-f0-9-]+)\/setting$/;
  if (siteSettingsRegex.test(path)) {
    const match = path.match(siteSettingsRegex);
    const site = match ? match[1] : undefined;
    return getSettings(site);
  }

  const siteRegex = /^\/site\/([a-f0-9-]+)$/;
  if (siteRegex.test(path)) {
    const match = path.match(siteRegex);
    const site = match ? match[1] : undefined;
    return getSiteDetails(site);
  }

  const performanceRegex =
    /^\/performance\/([a-f0-9-]+)\?window=(day|week|month|year)&start=(\d{4}-\d{1,2}-\d{1,2})(&end=\d{4}-\d{1,2}-\d{1,2})?$/;
  if (performanceRegex.test(path)) {
    const match = path.match(performanceRegex);
    const site = match ? match[1] : undefined;
    const window = match ? match[2] : undefined;
    const start = match ? match[3] : undefined;
    const end = match ? match[4] : undefined;
    return await getPerformance(site, window, start, end);
  }

  const planRegex =
    /^\/site\/([a-f0-9-]+)\/plan\?start=(\d{4}-\d{1,2}-\d{1,2}?)$/;
  if (planRegex.test(path)) {
    const match = path.match(planRegex);
    const site = match ? match[1] : undefined;
    return await getPlan(site);
  }

  const summaryRegex =
    /^\/summary\/([a-f0-9-]+)\?window=(day|week|month|year)&start=\d{4}-\d{1,2}-\d{1,2}(&end=\d{4}-\d{1,2}-\d{1,2})?$/;
  if (summaryRegex.test(path)) {
    return getSummary(path);
  }

  const notificationDetailsRegex =
    /^\/site\/([a-f0-9-]+)\/notification\/([a-f0-9-]+)$/;
  if (notificationDetailsRegex.test(path)) {
    const match = path.match(notificationDetailsRegex);
    const site = match ? match[1] : undefined;
    const notification = match ? match[2] : undefined;
    return getNotificationDetails(site, notification);
  }

  const notificationRegex = /^\/site\/([a-z0-9-]+)\/notification$/;
  if (notificationRegex.test(path)) {
    const match = path.match(notificationRegex);
    const site = match ? match[1] : undefined;
    return getNotificationList(site);
  }

  const unitOperationRegex = /^\/unit\/([a-f0-9-]+)\/operation\/([a-f0-9-]+)$/;
  if (unitOperationRegex.test(path)) {
    return getunitStormOperation();
  }

  const unitOperationListRegex = /^\/unit\/([a-f0-9-]+)\/operation$/;
  if (unitOperationListRegex.test(path)) {
    return getSettingsStormOperation();
  }

  const unitAplistRegex = /^\/unit\/([a-f0-9-]+)\/aplist$/;
  if (unitAplistRegex.test(path)) {
    return getNetworkAccessList();
  }

  const unitNetworkRegex = /^\/unit\/([a-f0-9-]+)\/network$/;
  if (unitNetworkRegex.test(path)) {
    return getNetworkSettings();
  }

  const siteTariffRegex = /^\/site\/([a-f0-9-]+)\/tariff$/;
  if (siteTariffRegex.test(path)) {
    const match = path.match(siteTariffRegex);
    const site = match ? match[1] : undefined;
    return getTariffList(site);
  }

  const siteVppKeyRegex = /^\/vpp_key\/([a-f0-9-]+)$/;
  if (siteVppKeyRegex.test(path)) {
    return getVppKey();
  }

  return {};
};

const post = (path) => {
  const unitOperationRegex = /^\/unit\/([a-f0-9-]+)\/operation$/;
  if (unitOperationRegex.test(path)) {
    return createunitEvBoostOperation();
  }
  return {};
};

const put = (path, options) => {
  const siteSettingsRegex = /^\/site\/([a-f0-9-]+)\/setting$/;
  if (siteSettingsRegex.test(path)) {
    return updateSettings(options.body);
  }

  return {};
};
